module.exports = __webpack_public_path__ + "static/media/13.8988776d.pdf";